__webpack_require__.p = "/Prateek-sPortfolio/";